import { render, staticRenderFns } from "./Sports.vue?vue&type=template&id=5092dea4&"
import script from "./Sports.vue?vue&type=script&lang=js&"
export * from "./Sports.vue?vue&type=script&lang=js&"
import style0 from "./Sports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports